import { PayloadAction } from '@reduxjs/toolkit';
import { Dispatch } from 'react';

import { getSWOTReportValues, saveSWOTReport } from '../../../services/database/swot';

import { saveSWOTReportAction } from './swot.slice';
import { GenerateSWOTReportDTO, SWOTReport } from './swot.types';
import { generateSWOTReport } from './swot.utils';

/**
 * retrieve previously saved values from the skills assessment
 */
export const dispatchGetSWOTReportValues =
  () =>
  async (dispatch: Dispatch<PayloadAction<SWOTReport>>): Promise<void> => {
    const swot: SWOTReport | undefined = await getSWOTReportValues();
    if (swot) {
      dispatch(saveSWOTReportAction(swot));
    }
  };

/**
 * update progress in the skills assessment
 */
export const dispatchGenerateSWOTReport =
  (dto: GenerateSWOTReportDTO) =>
  async (dispatch: Dispatch<PayloadAction<SWOTReport>>): Promise<void> => {
    const swot: SWOTReport = generateSWOTReport(dto);
    await saveSWOTReport(swot);
    dispatch(saveSWOTReportAction(swot));
  };
